import { EnumCacheEntityType } from "@/app/services/generated/enums/enumCacheEntityType.generated";
import type { ProductBrand } from "@/app/services/generated/productbrandService";
import { productBrandService } from "@/app/services/generated/productbrandService";
import {
  EntityWithGuidKeyCache,
  EntityCacheStore,
} from "@/app/caching/apiCache";

export interface IHasProductBrandsCache {
  productBrands: ProductBrandsCache;
}

// Singleton cache store
const productBrandsCacheStore = new EntityCacheStore<ProductBrand>(
  EnumCacheEntityType.productBrand,
  async () => productBrandService.getAllProductBrands()
);

// Ephemeral reader
export default class ProductBrandsCache extends EntityWithGuidKeyCache<ProductBrand> {
  constructor() {
    super(productBrandsCacheStore, (x) => x.id);
  }
}
